import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[autofocus]'
})
export class AutofocusDirective {
  private focus = true;
  private element;
  private selectInput: any;
  constructor(private el: ElementRef) {
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
    if (this.focus) {
      window.setTimeout(() => {
        this.selectInput.focus();
      });
    }
  }

  @Input() set autofocus(condition: any) {
    this.focus = condition[0];
    this.selectInput = condition[1];
  }

}
